import React from 'react';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import Table from 'react-bootstrap/Table';
import Alert from 'react-bootstrap/Alert';
import TablePagination from '../TablePagination';
import { FormattedMessage } from 'react-intl';

function RecordModal(props) {
  return (
    <Modal size='xl'
      className='RecordModal'
      show={props.show}
      onHide={() => {
        props.setShow(false);
      }}
      dialogClassName="modal-95w"
      centered
    >
      <Modal.Header className="bg_brand" closeButton>
        <Modal.Title>
          {props.selectedTitle}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {props.data.showAlert ?
          <Alert variant='danger' className='mb-2'>
            <span><FormattedMessage id='record.violating_ps' /></span>
          </Alert>
          : null}
        <Table responsive striped size="sm" className='mb-0 text-center'>
          <thead className={props.data.class}>
            <tr>
              {
                props.data.thead.map((row, index) => {
                  return (
                    <th key={index}>{row}</th>
                  )
                })
              }
            </tr>
          </thead>
          <tbody>
            {
              props.data.tbody.map((row, index) => {
                return (
                  <tr key={index}>
                    {
                      row.map((innerRow, innerIndex) => {
                        return (
                          <td key={innerIndex}>{innerRow}</td>
                        )
                      })
                    }
                  </tr>
                )
              })
            }
            {props.data.tbody.length === 0 ?
              <tr>
                <td colSpan={props.data.thead.length}><FormattedMessage id='global.no_data' /></td>
              </tr>
              : null}
          </tbody>
        </Table>
        {props.data.page ?
          <TablePagination config={props.config} onPageChange={props.data.onPageChange} totalpage={props.data.totalpage} currentpage={props.data.page} />
          : null
        }
      </Modal.Body>
      <Modal.Footer className='d-flex justify-content-end'>
        <Button className="bg_brand" variant="primary" onClick={() => props.setShow(false)}><FormattedMessage id='global.confirm' /></Button>
      </Modal.Footer>
    </Modal>
  )
}

export default RecordModal;